export default __webpack_public_path__ + "static/media/hockey_responsive.4bb8d2f1.png";